
(function (Drupal) {
  Drupal.behaviors.disableReCaptcha = {
    attach: function (context) {
      console.log('disableReCaptcha attach')

      once('disableReCaptcha', 'html', context).forEach(function(el) {
        console.log('disableReCaptcha once')

        var captchaSelector = '.webform-submission-form .captcha-type-challenge--recaptcha .g-recaptcha';
        var submitSelector = '.webform-submission-form .form-actions .form-submit';

        var recaptchaResponse = false;
        var captchaElements = context.querySelectorAll(captchaSelector);
        var hasCaptcha = (captchaElements.length > 0);
        console.log('hasCaptcha', hasCaptcha);
        // disable submit
        captchaElements.forEach(function(captchaElement) {
        });
//        if (grecaptcha) {
//          grecaptcha.getResponse('g-recaptcha');
//        }
      });
    }
  }
})(Drupal);
